export class ClientError extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    constructor(public message: string, public level: number, public type: string) {
        super(message);
    }
}

export function createClientErrorFromResponse(status: number, response: string): Error {
    try {
        const errorJson = JSON.parse(response);
        if (typeof errorJson.message === 'string' && typeof errorJson.level === 'string') {
            return new ClientError(errorJson.message, status, errorJson.level);
        }
    } catch {}
    return new Error(response);
}

export async function createClientError(response: Response): Promise<Error> {
    return createClientErrorFromResponse(response.status, await response.text());
}
